import { render, staticRenderFns } from "./NotificationGrouping.vue?vue&type=template&id=78d7d9fc&"
import script from "./NotificationGrouping.vue?vue&type=script&lang=js&"
export * from "./NotificationGrouping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports